/* ---------------------------------------------------------------------
   Full rows above a mid-grid banner.

   A listing's grid is printed in two halves with the banner between them,
   split after a fixed number of products. The number of columns is not
   fixed — two on a phone, three on a tablet, four or five on a desktop —
   so the first half ended on a part row at most widths: six products on
   five columns is a row of five and one on its own, with four empty
   cells beside it and the banner under that.

   This moves the leftover cards to the front of the second half, so the
   first half ends on a full row, and moves them back when the width
   changes. Nothing is reordered: the cards stay in the order the server
   printed them, only the banner's place among them shifts to the nearest
   row boundary. Runs on load, on resize and after a page is swapped in
   (assets/vro-page-swap.js). It stands aside while a Shop-by answer has
   rebuilt the grid, which lays itself out.
--------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__vroGridBalance) return;
  window.__vroGridBalance = true;

  var WRAPS = '.clp-grid-wrap, .plp-grid-wrap';
  var GRIDS = '.clp-grid, .plp-grid';

  function colsOf(grid) {
    var t = window.getComputedStyle(grid).gridTemplateColumns;
    if (!t || t === 'none') return 0;
    return t.split(' ').filter(Boolean).length;
  }
  function isCard(el) {
    return el.nodeType === 1 && el.classList.contains('feed-card');
  }
  function visible(el) {
    return !el.hidden && el.offsetParent !== null;
  }

  function pairs() {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll(WRAPS), function (wrap) {
      /* A narrowed listing (Shop-by, or a quiz answer) has redrawn the
         grid as one list of its own; leave that alone. */
      if (wrap.querySelector('.plp-shopby-more, [data-vro-plp-viewall]')) return;
      var grids = Array.prototype.filter.call(wrap.querySelectorAll(GRIDS), function (g) {
        return !g.closest('.plp-shopby-more');
      });
      if (grids.length < 2) return;
      out.push({ first: grids[0], rest: grids[1] });
    });
    return out;
  }

  function balance(pair) {
    var first = pair.first, rest = pair.rest;
    if (!visible(first) || !visible(rest)) return;
    /* The cards the server printed in the first half, in order, read once
       before anything is moved. */
    if (!first.__vroBalanceOrig) first.__vroBalanceOrig = Array.prototype.filter.call(first.children, isCard);
    var orig = first.__vroBalanceOrig;
    var cols = colsOf(first);
    if (!cols || !orig.length) return;

    var keep = Math.floor(orig.length / cols) * cols;
    if (keep < cols) keep = Math.min(cols, orig.length);

    /* Everything in the rest grid that is not one of ours marks where our
       leftovers go: in front of the first product the server put there. */
    var anchor = null;
    for (var i = 0; i < rest.children.length; i++) {
      if (orig.indexOf(rest.children[i]) === -1) { anchor = rest.children[i]; break; }
    }
    for (var j = 0; j < orig.length; j++) {
      var card = orig[j];
      if (j < keep) {
        if (card.parentNode !== first || card !== first.children[first.children.length - 1]) first.appendChild(card);
      } else {
        rest.insertBefore(card, anchor);
      }
    }
  }

  function run() {
    pairs().forEach(balance);
  }

  var timer = null;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', later);
  document.addEventListener('vro:grid:swapped', function () { setTimeout(run, 0); });
})();
